/**
 * URLs API stage Chalice `prod_mobile_booking` (app client iOS/Android uniquement).
 * Mis à jour automatiquement par scripts/deploy-prod-mobile-booking-api.sh après deploy.
 */
export const API_PRIMARY_MOBILE_BOOKING = 'https://lew692wom8.execute-api.eu-west-3.amazonaws.com/api';
export const API_SECONDARY_MOBILE_BOOKING = 'https://8znhwcdime.execute-api.eu-west-3.amazonaws.com/api';

export function isMobileBookingApiConfigured(): boolean {
  return Boolean(API_PRIMARY_MOBILE_BOOKING && API_SECONDARY_MOBILE_BOOKING);
}
